import styles from "./styles.module.scss";

interface DefaultProps {
  id: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  children: any;
  inputRef?: (ref: HTMLButtonElement) => void;
  onBlur?: (value: React.ChangeEvent<HTMLButtonElement>) => void;
}

interface Props extends DefaultProps {
  type?: "default" | "primary" | "unstyled" | "orange" | "blue";
  disabled?: boolean;
  title?: string;
}

export function ButtonAtom(props: Readonly<Props>) {
  let className: string = styles.button;

  if (props.type && props.type !== "default") {
    const style = styles[`button--${props.type}`];
    className += ` ${style}`;
  }

  return (
    <button
      id={props.id}
      type="button"
      disabled={props.disabled}
      className={className}
      onClick={props.onClick}
      title={props.title}
    >
      {props.children}
    </button>
  );
}

export function ButtonUnstyled(props: Readonly<Props>) {
  return (
    <button
      id={props.id}
      className={styles.lookalike}
      onClick={(event) => props.onClick(event)}
      type="button"
      disabled={props.disabled}
      title={props.title}
      onBlur={(value: React.ChangeEvent<HTMLButtonElement>) => (props.onBlur ? props.onBlur(value) : {})}
      ref={(ref: HTMLButtonElement) => {
        props.inputRef && ref && props.inputRef(ref);
      }}
    >
      {props.children}
    </button>
  );
}
